var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      staticClass: "app-main-inner",
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("SeaExport.MultiSegmentNumberRuleConfiguration"),
        width: "360px",
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "div",
        { staticClass: "app-main-inner-row" },
        [
          _c(
            "el-form",
            { attrs: { "label-width": "60px", "label-position": "left" } },
            [
              _c(
                "div",
                { staticClass: "el-form-item-wrapper" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.StartNumber") } },
                    [
                      _c("el-input", {
                        attrs: { no: "1" },
                        model: {
                          value: _vm.rulesForm.startNum,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.rulesForm,
                              "startNum",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "rulesForm.startNum"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("CargoMsg.Cargo_NumberOfCopies") }
                    },
                    [
                      _c("el-input-number", {
                        attrs: { no: "2", min: 1 },
                        model: {
                          value: _vm.rulesForm.numStep,
                          callback: function($$v) {
                            _vm.$set(_vm.rulesForm, "numStep", $$v)
                          },
                          expression: "rulesForm.numStep"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.IncrementalRule") } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { no: "3" },
                          model: {
                            value: _vm.rulesForm.rule,
                            callback: function($$v) {
                              _vm.$set(_vm.rulesForm, "rule", $$v)
                            },
                            expression: "rulesForm.rule"
                          }
                        },
                        _vm._l(_vm.ruleOptions, function(item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { value: item.value, label: item.label }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticStyle: { "text-align": "center" },
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            { attrs: { no: "4", type: "primary" }, on: { click: _vm.confirm } },
            [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
          ),
          _c("el-button", { attrs: { no: "5" }, on: { click: _vm.cancel } }, [
            _vm._v(_vm._s(_vm.$t("common.btn.cancel")))
          ]),
          _c(
            "el-button",
            {
              attrs: { no: "6", type: "primary" },
              on: { click: _vm.exportHandle }
            },
            [_vm._v(_vm._s(_vm.$t("SeaExport.DirectExport")))]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }